import {css, keyframes} from 'styled-components';

import {RepositionPlacement} from '../reposition/repositionHelpers';

const scale = 0.95;

/*
 * Animation keyframes for different tooltip origins.
 */

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(${scale});
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

/*
 * Helper to get transform origin based on placement.
 */

export function getTransformOrigin(placement: RepositionPlacement) {
  const [base, alignment] = placement.split('-');

  switch (base) {
    case 'top':
      if (alignment === 'start') {
        return 'left bottom';
      }
      if (alignment === 'end') {
        return 'right bottom';
      }
      return 'center bottom';
    case 'bottom':
      if (alignment === 'start') {
        return 'left top';
      }
      if (alignment === 'end') {
        return 'right top';
      }
      return 'center top';
    case 'left':
      if (alignment === 'start') {
        return 'right top';
      }
      if (alignment === 'end') {
        return 'right bottom';
      }
      return 'right center';
    case 'right':
      if (alignment === 'start') {
        return 'left top';
      }
      if (alignment === 'end') {
        return 'left bottom';
      }
      return 'left center';
    case 'cursor':
      return 'center center';
    default:
      return 'center top';
  }
}

/*
 * CSS for tooltip animation.
 */

export function getTooltipAnimationCss(placement: RepositionPlacement) {
  const transformOrigin = getTransformOrigin(placement);

  return css`
    animation: ${fadeIn} 100ms cubic-bezier(0.4, 0, 0.2, 1);
    transform-origin: ${transformOrigin};
    will-change: transform, opacity;
  `;
}
